import { useEffect } from "react";

import { useWizardSession } from "@/hooks/useWizardSession";
import { useWizardResult, useWizardState } from "@/hooks/wizardQueries";

/**
 * Hydrates apply result from the server when the in-memory session was lost (page refresh).
 */
export function useWizardSessionRestore() {
  const session = useWizardSession();
  const wizardState = useWizardState();
  const resultQuery = useWizardResult(
    !session.applyResult &&
      (!!wizardState.data?.lastAppliedAt || wizardState.data?.phase === "completed"),
  );

  useEffect(() => {
    if (resultQuery.data && !session.applyResult) {
      session.setApplyResult(resultQuery.data);
    }
  }, [resultQuery.data, session]);
}
